import { useState } from "react";
import useApiRequest from "../../helpers/api_request";
import useErrorToast from "../../helpers/errorToast";
import { useAppSelector } from "../../app/hooks";
import { selectAccessToken } from "../../features/auth/authSlice";
import { BASE_URL } from "../../helpers/constants";

const usePermissionsRequest =()=>{
    const [fetchingPermissions, setFetchingPermissions] = useState(false);
    const [permissions, setPermissions] = useState<string[]>([]);
    const apiRequest = useApiRequest()
    const errorToast = useErrorToast()
    const accessToken = useAppSelector(selectAccessToken);

    const getPermissions = async()=>{
        setFetchingPermissions(true);
        await apiRequest({
            method: 'get',
            url: BASE_URL + "/api/role/permissions",
            headers: {
                Authorization: `Bearer ${accessToken}`,
              },
          }).then((response) => {
            setPermissions(response.data)
            setFetchingPermissions(false)        
          }).catch((error) => {
            errorToast(error);
            setFetchingPermissions(false)
          });
    }

    return {
        getPermissions,
        fetchingPermissions,
        permissions
    }
}

export default usePermissionsRequest;
